import { Checkbox, Field } from '@workwhile/ui'
import React, { useMemo } from 'react'
import { useFormContext } from 'react-hook-form'
import { FiltersSchema } from '../../filtersSchema'
import { rosterRestrictions } from './constants'

export const RosterRestrictionsFilter = () => {
  const { setValue, watch } = useFormContext<FiltersSchema>()

  const rosterRestrictionsValue = watch('shift.rosterRestrictions') ?? []

  const selectableColumnsCheckboxes = useMemo(() => {
    return rosterRestrictions.map(({ id, label }) => {
      const isSelected = rosterRestrictionsValue.includes(id)
      return (
        <Field key={`roster-types-filter-${id}`}>
          <Checkbox
            value={isSelected}
            onChange={(checked) => {
              if (!checked) {
                setValue(
                  'shift.rosterRestrictions',
                  rosterRestrictionsValue.filter((type) => type !== id)
                )
              } else {
                setValue('shift.rosterRestrictions', [
                  ...rosterRestrictionsValue,
                  id,
                ])
              }
            }}
          >
            <span>{label}</span>
          </Checkbox>
        </Field>
      )
    })
  }, [rosterRestrictionsValue])

  return selectableColumnsCheckboxes
}
